import { render, staticRenderFns } from "./selectModal.vue?vue&type=template&id=2dece893&scoped=true"
import script from "./selectModal.vue?vue&type=script&lang=js"
export * from "./selectModal.vue?vue&type=script&lang=js"
import style0 from "./selectModal.vue?vue&type=style&index=0&id=2dece893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dece893",
  null
  
)

export default component.exports